// /frontend/src/components/routes/AdminRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AdminRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useSelector((state) => state.auth);
  const location = useLocation();

  // If the authentication is still being checked, show a loading spinner
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-teal-800"></div>
      </div>
    );
  }

  // If not authenticated or not admin, redirect to admin login with return URL
  if (!isAuthenticated || user?.role !== 'admin') {
    return <Navigate to={`/admin/login?redirect=${location.pathname}`} replace />;
  }

  // If authenticated and admin, show the protected component
  return children;
};

export default AdminRoute;